import React from "react";

export default function UserIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_138_1422"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_138_1422)">
        <path
          d="M10.0007 9.99967C9.08398 9.99967 8.29926 9.67329 7.64648 9.02051C6.99371 8.36773 6.66732 7.58301 6.66732 6.66634C6.66732 5.74967 6.99371 4.96495 7.64648 4.31217C8.29926 3.6594 9.08398 3.33301 10.0007 3.33301C10.9173 3.33301 11.702 3.6594 12.3548 4.31217C13.0076 4.96495 13.334 5.74967 13.334 6.66634C13.334 7.58301 13.0076 8.36773 12.3548 9.02051C11.702 9.67329 10.9173 9.99967 10.0007 9.99967ZM3.33398 14.9997V14.333C3.33398 13.8608 3.45551 13.4268 3.69857 13.0309C3.94162 12.6351 4.26454 12.333 4.66732 12.1247C5.52843 11.6941 6.40343 11.3712 7.29232 11.1559C8.18121 10.9406 9.08398 10.833 10.0007 10.833C10.9173 10.833 11.8201 10.9406 12.709 11.1559C13.5979 11.3712 14.4729 11.6941 15.334 12.1247C15.7368 12.333 16.0597 12.6351 16.3027 13.0309C16.5458 13.4268 16.6673 13.8608 16.6673 14.333V14.9997C16.6673 15.458 16.5041 15.8504 16.1777 16.1768C15.8513 16.5031 15.459 16.6663 15.0007 16.6663H5.00065C4.54232 16.6663 4.14996 16.5031 3.82357 16.1768C3.49718 15.8504 3.33398 15.458 3.33398 14.9997ZM5.00065 14.9997H15.0007V14.333C15.0007 14.1802 14.9625 14.0413 14.8861 13.9163C14.8097 13.7913 14.709 13.6941 14.584 13.6247C13.834 13.2497 13.077 12.9684 12.3132 12.7809C11.5493 12.5934 10.7784 12.4997 10.0007 12.4997C9.22287 12.4997 8.45204 12.5934 7.68815 12.7809C6.92426 12.9684 6.16732 13.2497 5.41732 13.6247C5.29232 13.6941 5.19162 13.7913 5.11523 13.9163C5.03885 14.0413 5.00065 14.1802 5.00065 14.333V14.9997ZM10.0007 8.33301C10.459 8.33301 10.8513 8.16981 11.1777 7.84342C11.5041 7.51704 11.6673 7.12467 11.6673 6.66634C11.6673 6.20801 11.5041 5.81565 11.1777 5.48926C10.8513 5.16287 10.459 4.99967 10.0007 4.99967C9.54232 4.99967 9.14996 5.16287 8.82357 5.48926C8.49718 5.81565 8.33398 6.20801 8.33398 6.66634C8.33398 7.12467 8.49718 7.51704 8.82357 7.84342C9.14996 8.16981 9.54232 8.33301 10.0007 8.33301Z"
          fill="#505050"
        />
      </g>
    </svg>
  );
}
